// Sources for analytics
export const SLACKID_ONBOARDING_MODAL = 'slackid-onboarding-modal';
